<template>
	<div>
		<a-modal centered v-model:visible="modalVisible" :width="900" :footer="null" @cancel="cancel">
			<div  style="    width: 100%;">
				<div class="scrollViewModal">
					<a-spin :spinning="reloading">
						<div class="subscribeModal">
							<div style="padding-bottom:10px">
								<!--文章类别-->
								<div>
									<div class="custom-block">
										<text>已选用文章类别</text>
									</div>
									<div class="u-flex u-flex-wrap" style="   margin-top: 1rem;    max-height: 114px;overflow-y: auto;">
										<template v-for="(item, index) in parentCategories" v-bind:key="index">
											<button v-if="item.id!=55"  style="margin:0.2rem" class="ubutton-class" :style="{
			border: 'none', 'color': item.checked == true ? 'white' : '#0FC1CB',
			'border': item.checked == true ? '1px solid #a0cfff' : '', 'background-color': item.checked == true ? '#0FC1CB' : '#F5F8FD', 'padding': '0 20rpx', 'font-size': '25rpx',


		}"  :throttle-time="200" @click="tagCategoryClick(index)"
											>
											<svg-icon class="svgIcon" name="星" size="10" 
												:color="item.checked == true ? '#ffffff' : '#b8dced'"
												style="    margin-right: 0px;    position: absolute;right: 5px;top: 2px;"></svg-icon>
											{{ item.name }}</button>
										</template>
							
									</div>
								</div>
								<div style="margin-top: 1rem;margin-bottom: 1rem;">
									<div style="position: relative">
										<div class="custom-block">
											<text>添加关键词</text>
										</div>
										<div style="   margin-top: 1rem;display: flex;align-items: center;">
											<a-input style="width: 80%;" v-model:value="keyword" placeholder='请输入关键词，关键词不能含有特殊符号'
												@change="onInput"></a-input>
											<a-button class=" inputView" @click="toAdd">
												<plus-outlined />添加
											</a-button>

										</div>
									
									</div>
									<div style="margin-top: 1rem;margin-bottom: 1rem;">
										<div class="custom-block">
											<text>已订阅关键词</text>
										</div>
										<div class="u-flex u-flex-wrap"
											style="   margin-top: 1rem;height: 300px;overflow-y: auto;">
											<button style="margin:0.2rem" class="ubutton-class-keyword" :style="{
			border: 'none', 'color': '#805D13',
			'border': '1px solid #a0cfff', 'background-color': '#FFD274', 'padding': '0 20rpx', 'font-size': '25rpx',
			'height': ' 60rpx', 'padding': '0px 3px',
			'line-height': '60rpx'
		}" v-bind:key="index" :throttle-time="200" @click="tagClick(0, item)" v-for="(item, index) in keywordList">{{
			item.name }} ×</button>
										</div>
									</div>
								
								</div>
							</div>
						</div>
					</a-spin>
				</div>
				<div style="text-align:center">
					<a-button class="inputView" @click="toSubmit" style="display: inline;">完成设置</a-button>
				</div>
			</div>
		</a-modal>


	</div>

	<a-modal centered width="20%" title="" v-model:visible="visible" :afterClose="afterClose" :closable="false"
		:footer="null">
		<div style="text-align: center;">
			<div style="    padding: 20px; 
					text-align: center;" @click="show = false">
				<div style="       font-size: 22px;
						display: flex;
						width: 100%;align-items:center;justify-content:center;">
					<check-circle-outlined v-if="num > 0" class="iconStyle success" />
					<exclamation-circle-outlined v-else class="iconStyle warning" />
					设置完成
				</div>
				<div v-if="num > 0" class="mr20">已更新{{ num }}篇情报</div>
				<div v-else class="mr20">您的订阅词匹配上的内容较少，建议您重新修改订阅词</div>
			</div>
			<div>
				<a-button @click="iKnow" type="primary">我知道了</a-button>
			</div>
		</div>
	</a-modal>

</template>

<script setup>
import { PlusOutlined, ExclamationCircleOutlined, CheckCircleOutlined } from "@ant-design/icons-vue";
import { hilight_str } from '../../../untils/index'
import { ref, watch, nextTick } from 'vue'
import { getMySubscription, setMysubscription,setMysubscriptionManage,getAllSubscription} from './index'
// import { myCategoryList, outsideEmployeeCategoryList } from '../article/newSubscibe/js/index'
import store from '@/store'
import { message } from 'ant-design-vue/lib/components'
import router from "@/router"
const showProp =defineProps({
	showModalKeywordVisible: { default: false, type: Boolean },
	clientId: { default: null, type: [Object,Number] },
})
const showEmit = defineEmits(['toShowKeyword', 'reloaddataKeyword'])
const modalVisible = ref(false)
watch(() => showProp.showModalKeywordVisible, (val) => {
	
		modalVisible.value = val
		if (val == true) toGetKeyword()
})
const mySubscription=ref()
const toGetKeyword = () => {
	reloading.value = true
	if(showProp.clientId)
	getAllSubscription({companyId:store.getters.company.companyId}).then((res)=>{
		setKeyword(res.data.find(item=>item.clientId==showProp.clientId))
})
	else 
	getMySubscription({companyId:store.getters.company.companyId}).then((res)=>{
		setKeyword(res.data)
		
	})

	}
	const setKeyword=(res)=>{
		mySubscription.value=res
		var list = []
		var keywordListList = []
		if(mySubscription.value.keywords){
			list=mySubscription.value.keywords
	
			list=list.split('|')
			for(var i in list){
				keywordListList.push({name:list[i],choose:true})
		
			}
		}

		keywordList.value = keywordListList
		getCategory()
	}
	const getCategory = () => {
		
			var list =store.getters.INTSort
			var selectList=[]
			if(mySubscription.value.categoryIds){
				selectList= mySubscription.value.categoryIds
			}
	
			for(var i in list){
				 list[i].checked=selectList.findIndex(item=>Number(item)==list[i].id)>-1?true:false
				 if( list[i].id==55)
				 list[i].checked=false
			}
		
			parentCategories.value  =list
			reloading.value = false

		}
		const toSplitKeyword = (val) => {
			if (val == '' || val == null) return []
			else return val.split('|')
		}
		const childrenCategories = ref([])
		const parentCategories = ref([])
		const selectList = ref([])
		const noList = ref([])
		const keywordList = ref([])
	
		const tagClick = (key, val) => {
	
	
			var index = 0

			index = keywordList.value.findIndex(item => item.name == val.name)
			keywordList.value.splice(index, 1)
				
				
			
		}
		const keyword = ref('')
		const tagCategoryClick = (index) => {
		
			parentCategories.value[index].checked = !parentCategories.value[index].checked
		}
		const onInput = () => {
			if (keyword.value == '' || keyword.value.replaceAll(' ', '') == '') {
				keyword.value = ''

			 
			}
	
			keyword.value = keyword.value.replace(/\s+/g, ' ')
		}
		const searchList = ref([])
		const toAdd = () => {
			const regex = /[~!%@#$^&*()\-_=|{}':;',\[\].<>\/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？\\]/
		
		
			if(regex.test(keyword.value)){
				message.warning('关键词不能含有特殊符号')
			}
			else if (keyword.value != '') {
				
				var key = keyword.value.replace(/\s+/g, ' ').trim().split("|")
			
				for (var i in key) {
					if (key[i].replaceAll(' ', '') != '') {
						if (!keywordList.value.find(item => item.name == key[i].trim())) {
							var item = {
								name: key[i].trim(),
								choose: true,
								
							}
							keywordList.value.push(item)
					
						}
						else {
							if (key.length == 1 && keywordList.value.find(item => item.name == key[i].trim() && item.choose == true)) {
								message.warning('关键词已存在')
							}

						}
					}
				}
		
				keyword.value = ''
		
			}
		}
		const toSubmit = () => {
			var i
			var parentCategoriesList = parentCategories.value.filter(item => item.checked == true)
			if(parentCategoriesList.length==0){
				message.warning('请选择文章类别')
			}
			else if (keywordList.value.length == 0) {
				message.warning('关键词不能为空')
			}
			else {
				var categoryIds = []
				for (i in parentCategoriesList) {
					categoryIds.push(parentCategoriesList[i].id)
				}
	
				var keyword = []
				var keywordListList = keywordList.value.filter(item => item.choose == true)
				for (i in keywordListList) {
					keyword.push(keywordListList[i].name)
				}
				toPostSubmit(keyword, categoryIds)
			}
		},
			toPostSubmit = (keyword, categoryIds) => {
				reloading.value = true
				console.log(keyword, categoryIds)
				keyword = keyword.toString().replaceAll(',', '|')
			
				var list = {
					"companyId": store.getters.company.companyId,
					"keywords": keyword,
					"categoryIds": categoryIds
				}
				if(showProp.clientId)
				setMysubscriptionManage({clientId:showProp.clientId,post:list}).then((res) => {
					message.success('设置成功！')
					 showEmit('toShowKeyword',true)
				})
				else 
				setMysubscription(list).then((res) => {
					message.success('设置成功！')
					 showEmit('toShowKeyword',true)
				})
		
			}
		const reloading = ref(false)
		const num = ref(0)
		const visible = ref(false)
		const afterClose = () => {
			visible.value = false
		}
		const iKnow = () => {
			visible.value = false
			store.dispatch("reloadFlag", true)
			store.dispatch("reloadINTFlag", true)
			router.push({ name: 'homePage' })
		}


		const reloadFlag = ref(false)
		const cancel=()=>{
			showEmit('toShowKeyword',false)

		}
		
	

</script>
<style>
.tablestyle .ant-table-thead>tr>th,
.ant-table-tbody>tr>td {
	padding: 8px 8px !important;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.tablestyle {
	margin-top: 20px;
}

.scrollViewModal {
	margin: 10px 0px;
}

.datelist {
	margin-left: 10px;
	display: inline-block;
}

.datelist a {
	margin-right: 10px;
}
</style>
<style scoped>


.searchView {
	position: absolute;
	z-index: 100;
	background: white;
	left: 0;
	width: 80%;
}

.back {
	margin-left: 32upx;
	width: 48upx;
	height: 48upx;
	border-radius: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
}
</style>
<style scope lang="scss">
.iconStyle {
	font-size: 32px;
	margin-right: 5px;

	&.success {
		color: green;
	}

	&.warning {
		color: orange;
	}
}

.mr20 {
	margin-top: 20px
}

.inputView {
	width: 20%;
	background-color: #0FC1CB !important;
	border-color: #0FC1CB!important;
	color: white !important;
	display: flex;
	min-height: 35px;
	align-items: center;
	justify-content: center;
}


.inputView:hover,
.inputView:focus,
.inputView:active {
	color: white;
	background-color: #29cad3;
	border-color: #0FC1CB;
}


.ubutton-class {
	padding: 0 10px !important;
	border: none !important;
	cursor: pointer;
	position: relative;
	border-radius: 5px;
	line-height: 50px;
	font-size: 12px;

	.u-hairline-border::after {
		border: none !important;
	}


}

.ubutton-class-keyword {
	padding: 0 10px !important;
	border: none !important;
	cursor: pointer;

	.u-hairline-border::after {
		border: none !important;
	}

	line-height: 30px;
}

.ubutton-class-keyword:hover {
	color: #ECAE3E !important;
	background-color: #FFFDF5 !important;
}



.subscribeModal {
	padding: 20px;

}

.custom-block {
	padding: .1rem .5rem;
	border-color: #00b2b9;
	border-left-width: .2rem;
	border-left-style: solid;
}

.footerButton {
	position: fixed;
	display: flex;
	width: 100%;
	justify-content: center;
	background: white;
	height: 50px;
	z-index: 100;
}

.star-five {
	width: 0;
	height: 0;
	color: red;
	margin: 100px 0;
	position: relative;
	display: block;
	border-left: 100px solid transparent;
	border-right: 100px solid transparent;
	border-bottom: 70px solid red;
	-moz-transfrom: rotate(35deg);
	-webkit-transform: rotate(35deg);
	-ms-transform: rotate(35deg);
	-o-transform: rotate(35deg);
}


.star-five:before {
	width: 0;
	height: 0;
	border-left: 30px solid transparent;
	border-right: 30px solid transparent;
	border-bottom: 80px solid red;
	position: absolute;
	top: -45px;
	left: -65px;
	color: white;
	display: block;
	content: "";
	-moz-transform: rotate(-35deg);
	-webkit-transform: rotate(-35deg);
	-ms-transform: rotate(-35deg);
	-o-transform: rotate(-35deg);
}

.star-five:after {
	width: 0;
	height: 0;
	display: block;
	position: absolute;
	color: red;
	top: 3px;
	left: -105px;
	border-left: 100px solid transparent;
	border-right: 100px solid transparent;
	border-bottom: 70px solid red;
	content: "";
	-moz-transform: rotate(-70deg);
	-webkit-transform: rotate(-70deg);
	-ms-transform: rotate(-70deg);
	-o-transform: rotate(-70deg);
}
</style>
